import { FC, useEffect, useLayoutEffect } from 'react';

import Helmet from '@/components/meta/Helmet';
import GuideAboutTemplate from '@/components/templates/Guide/About';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';

import { GuidePageTitles } from './types';

const GuideAboutPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs([
      {
        name: 'ご利用ガイド',
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  return (
    <>
      <Helmet
        meta={{
          title: GuidePageTitles.About,
          description:
            'DMM競輪のご利用ガイドページ。DMM競輪は、スマートフォンやパソコンでいつでもどこでもカンタンに競輪投票やチャリロト・Dokanto!の購入ができるサービスです。',
          keywords: `${GuidePageTitles.About},ご利用ガイド,%s`,
        }}
      />
      <GuideAboutTemplate />
    </>
  );
};

export default GuideAboutPage;
